import { siteStats, valuesList } from "../../../mocks/site";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-heart-3-line" /> 关于吃瓜爆网
            </span>
            <h2 className="font-heading mt-2 text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              把真正出圈的好内容，
              <br /> 选出来送到你面前
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              吃瓜爆网是一个专注爆款视频合集盘点与出圈短视频热门速递的内容平台。我们相信，在信息过载的时代，帮用户省时间、省流量、省眼睛，本身就是一种价值。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              我们坚持内容原则，以真实热度为准绳，以尊重版权为底线，以多元有趣为方向。无论你钟爱高能名场面、神反转还是治愈日常，都能在这里快速找到值得刷到结尾的看点。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {siteStats.map((s) => (
                <div
                  key={s.key}
                  className="rounded-xl border border-background-200 bg-background-100 p-4 text-center"
                >
                  <div className="font-heading text-xl font-black text-primary-600 md:text-2xl">
                    {s.value}
                  </div>
                  <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* values */}
          <div className="grid gap-4 sm:grid-cols-2">
            {valuesList.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${v.icon} text-xl`} />
                </span>
                <h3 className="font-heading mt-4 text-lg font-bold text-foreground-900">
                  {v.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}